import styles from './Button.module.css'

export function PrimaryButton({ children, onClick, isLoading }) {
    return (
        <button onClick={onClick} className={styles.primary}>
            {isLoading && "Carregando..."}
            {!isLoading && children}
        </button>
    )
}

export function SecondaryButton({ children, onClick, isLoading }) {
    return (
        <button onClick={onClick} className={styles.secondary}>
            {isLoading && "Carregando..."}
            {!isLoading && children}
        </button>
    )
}